// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"22efc1e5","239":"bc6c927b","453":"aa15a552","553":"a482041d"}[chunkId] + ".chunk.js";
};